import { render, staticRenderFns } from "./Navbaranimated.vue?vue&type=template&id=6b55a40a&"
import script from "./Navbaranimated.vue?vue&type=script&lang=js&"
export * from "./Navbaranimated.vue?vue&type=script&lang=js&"
import style0 from "./Navbaranimated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/buildhome/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
installComponents(component, {VDivider,VImg,VList})
